import React, { useEffect } from 'react'
import BaseModal from './BaseModal'
import { Col, Modal, Row } from 'react-bootstrap'

function SpinResultPopupModal({ show, onHide, data, ...otherProps }) {

  useEffect(() => {
    let timeoutId;
    if (show) {
      timeoutId = setTimeout(() => {
        onHide()
      }, 7000)
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [show])

	return (
		<BaseModal
			show={show}
			onHide={onHide}
			hideDecor={true}
			congrats
			spinResult
			{...otherProps}
		>
			<Modal.Body className="py-0">
				<div className="popup-result">
					<Row className="popup-content-result-box">
						<Col>
							{data.slice(0, 5).map((item, index) => (
								<div key={index}>
									<span>{index + 1}</span>
									<span className="">{item.label}</span>
								</div>
							))}
						</Col>
						<Col>
							{data.slice(5).map((item, index) => (
								<div key={index}>
									<span>{index + 6}</span>
									<span className="">{item.label}</span>
								</div>
							))}
						</Col>
					</Row>
				</div>
				{/* <div className="d-flex justify-content-center align-items-center racer-wrapper">
					<img src={racerS} alt="" className="racer" />
				</div> */}
			</Modal.Body>
		</BaseModal>
	)
}

export default SpinResultPopupModal
